import { EmploymentType } from "../../utils/models";

export type TeamSection = {
	readonly title: string;
	readonly employmentTypes: readonly EmploymentType[];
};

export const TEAM_SECTIONS: readonly TeamSection[] = [
	{
		title: "Full Time",
		employmentTypes: [EmploymentType.FullTime],
	},
	{
		title: "Part Time",
		employmentTypes: [EmploymentType.PartTime],
	},
	{
		title: "PRN",
		employmentTypes: [EmploymentType.PRN],
	},
	{
		title: "Agency",
		employmentTypes: [EmploymentType.Travel, EmploymentType.PerDiem],
	},
	{
		title: "Unknown",
		employmentTypes: [EmploymentType.Unknown],
	},
] as const satisfies readonly TeamSection[];

/**
 * Shared filter rule used to decide whether a row matches the active
 * Contract Type selection. An empty set means "no filter active".
 */
export function matchesContractSections(employmentType: EmploymentType, selectedSections: ReadonlySet<string>): boolean {
	if (selectedSections.size === 0) return true;
	return TEAM_SECTIONS.some((section) => selectedSections.has(section.title) && section.employmentTypes.includes(employmentType));
}

export type TeamStatsModel = {
	totalStaff: number;
	activeStaff: number;
	openShifts: number;
	activeUsersOnApp: number;
	onBoarded: number;
	selfSchedulingSubmissions?: number;
	activeNursesInPastOrNextMonth: number;
};
